module.exports = __webpack_public_path__ + "img/arr.961dd660.svg";